var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "custom-input-group",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.goSearchUnit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "form-obj-flex" }, [
        _c("div", { staticClass: "form-flex-area obj" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.unitname,
                expression: "unitname"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: _vm.placeholder(),
              autocomplete: "off"
            },
            domProps: { value: _vm.unitname },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.unitname = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-btn" }, [
        _c("div", { staticClass: "searchbox-obj" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: {
                type: "submit",
                tabindex: "0",
                "aria-label": _vm.buttonLabel()
              }
            },
            [
              _c("i", {
                staticClass: "fa-sharp fa-light fa-search",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.voMsg("tpl.search.btn.search")))
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }